/** Mirrors backend App\Support\LeadSources::ALLOWED */
export const LEAD_SOURCE_OPTIONS = [
  { value: 'phone', label: 'Phone' },
  { value: 'email', label: 'Email' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'estimate', label: 'Estimate (accepted)' },
  { value: 'google', label: 'Google Ads / Search' },
  { value: 'referral', label: 'Referral' },
  { value: 'angi', label: 'Angi / HomeAdvisor' },
  { value: 'website', label: 'Website' },
  { value: 'online_booking', label: 'Online booking' },
  { value: 'facebook', label: 'Facebook / Meta' },
  { value: 'other', label: 'Other' },
];

const LABEL_MAP = Object.fromEntries(LEAD_SOURCE_OPTIONS.map((o) => [o.value, o.label]));

export function labelForLeadSource(value) {
  if (value == null || value === '') return '';
  return LABEL_MAP[value] || value;
}
